export default "__VITE_ASSET__BOPhgZwF__"